import React from 'react';
import '../../App.css';
import {Icon} from 'office-ui-fabric-react';

const ResistanceCellRenderer: React.FC<any> = (params) => {
    // console.log(params)
   const tooltipField = params.colDef.tooltipField;
   const tooltip = params.data[tooltipField];

    return (
        <>
        {tooltip ? <span style={{cursor:'help'}}>{params.value}<Icon iconName="Info" className="gemu-rs-cell-icon"></Icon></span> : <span>{params.value}</span> }
        </>
    )
}

export default ResistanceCellRenderer;